import Affiliate from './Affiliate';
import MealPlannerRoutes from './MealPlanner';
import BetaFeaturesRoutes from './BetaFeatures';
import CensorshipRoutes from './Censorship';
import CollectionRoutes from './Collection';
import LiveShow from './LiveShow';
import MyPageRoutes from './MyPage';
import PostManagement from './PostManagement';
import RebateTncRoutes from './RebateTnc';
import ReportRoutes from './Report';
import ReservedProfileIdRoutes from './ReservedProfileId';
import SettingRoutes from './Setting';
import UserGroupsRoutes from './UserGroups';
import VodRoutes from './Vod';
import WhitelistDomainsRoutes from './WhitelistDomains';

const mainRouters = [
  ...MealPlannerRoutes,
  ...CensorshipRoutes,
  ...PostManagement,
  ...VodRoutes,
  ...ReportRoutes,
  ...SettingRoutes,
  ...RebateTncRoutes,
  ...ReservedProfileIdRoutes,
  ...LiveShow,
  ...WhitelistDomainsRoutes,
  ...Affiliate,
  ...CollectionRoutes,
  ...MyPageRoutes,
  ...BetaFeaturesRoutes,
  ...UserGroupsRoutes,
];
export default mainRouters;
